module.exports = "/static/assets/c2073917e0491bdcb2d046d298bcd083.png";